/* tslint:disable */
/* eslint-disable */
/* @relayHash c303a8d212a7d24287a61e795bb015bd */

import { ConcreteRequest } from "relay-runtime";
export type RequestBackgroundCheckLoaderMutationVariables = {
    delegateUUID: string;
    requestDBS: boolean;
    isRenewal?: boolean | null;
    onlyDBS?: boolean | null;
    idExpiry?: string | null;
    isCAA?: boolean | null;
};
export type RequestBackgroundCheckLoaderMutationResponse = {
    readonly requestBackgroundCheck: boolean;
};
export type RequestBackgroundCheckLoaderMutation = {
    readonly response: RequestBackgroundCheckLoaderMutationResponse;
    readonly variables: RequestBackgroundCheckLoaderMutationVariables;
};



/*
mutation RequestBackgroundCheckLoaderMutation(
  $delegateUUID: UUID!
  $requestDBS: Boolean!
  $isRenewal: Boolean
  $onlyDBS: Boolean
  $idExpiry: Time
  $isCAA: Boolean
) {
  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, isRenewal: $isRenewal, onlyDBS: $onlyDBS, idExpiryDate: $idExpiry, isCAA: $isCAA)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "delegateUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "requestDBS",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isRenewal",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "onlyDBS",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "idExpiry",
            "type": "Time",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isCAA",
            "type": "Boolean",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "requestBackgroundCheck",
            "args": [
                {
                    "kind": "Variable",
                    "name": "delegateUUID",
                    "variableName": "delegateUUID"
                },
                {
                    "kind": "Variable",
                    "name": "idExpiryDate",
                    "variableName": "idExpiry"
                },
                {
                    "kind": "Variable",
                    "name": "isCAA",
                    "variableName": "isCAA"
                },
                {
                    "kind": "Variable",
                    "name": "isRenewal",
                    "variableName": "isRenewal"
                },
                {
                    "kind": "Variable",
                    "name": "onlyDBS",
                    "variableName": "onlyDBS"
                },
                {
                    "kind": "Variable",
                    "name": "requestDBS",
                    "variableName": "requestDBS"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RequestBackgroundCheckLoaderMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RequestBackgroundCheckLoaderMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RequestBackgroundCheckLoaderMutation",
            "id": null,
            "text": "mutation RequestBackgroundCheckLoaderMutation(\n  $delegateUUID: UUID!\n  $requestDBS: Boolean!\n  $isRenewal: Boolean\n  $onlyDBS: Boolean\n  $idExpiry: Time\n  $isCAA: Boolean\n) {\n  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, isRenewal: $isRenewal, onlyDBS: $onlyDBS, idExpiryDate: $idExpiry, isCAA: $isCAA)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'd663b3f4e06352eca486c955f556e52a';
export default node;
